export class Value {
    constructor(private value: string | number | undefined) {}

    toBoolean(defaultValue?: boolean) {
        if (typeof this.value === "number") return !!this.value
        if (typeof this.value === "string") return !!parseInt(this.value, 2)
        return defaultValue ?? false
    }

    toString(defaultValue?: string) {
        if (typeof this.value === "string") return this.value
        if (typeof this.value === "number") return this.value.toString()
        return defaultValue ?? ""
    }
}
